import { useEffect } from 'react';

const DEFAULT_TITLE = 'Project Maintenance Perth - PMP';

/**
 * Updates the browser tab title while the component is mounted, then resets
 * back to the default on unmount. Pass a falsy value to keep the default
 * (useful while data is still loading).
 */
export function usePageTitle(title) {
  useEffect(() => {
    if (title) {
      document.title = `${title} - PMP`;
    }
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title]);
}
